export const VEHICLE_TYPE = "VEHICLE_TYPE";
export const VEHICLE_TYPE_SUCCESS = "VEHICLE_TYPE_SUCCESS";
export const VEHICLE_TYPE_FAIL = "VEHICLE_TYPE_FAIL";
